export type MethodStep = {
  title: string;
  text: string;
};

export const methodSteps: MethodStep[] = [
  {
    title: 'Comprendre le territoire',
    text: 'Diagnostic partagé croisant données statistiques, analyse de terrain et écoute des habitants et partenaires.',
  },
  {
    title: 'Construire la stratégie',
    text: 'Scénarios argumentés, arbitrages accompagnés auprès des élus et formalisation d’orientations opérationnelles.',
  },
  {
    title: 'Mettre en œuvre',
    text: 'Programmation, montage financier, coordination des maîtrises d’ouvrage et animation des instances de pilotage.',
  },
  {
    title: 'Évaluer et ajuster',
    text: 'Indicateurs de suivi, bilans à mi-parcours et recommandations pour adapter l’action publique dans la durée.',
  },
];
